import { Link } from './Link';

export type { LinkProps } from './types';
export default Link;
